import { Component } from '@angular/core';

@Component({
  selector: 'subtitle-component',
  templateUrl: './subtitle.component.html'
})
export class SubtitleComponent {}
